<template>
  <div class="row px-0">
    <div class="col-md-6">
      <IncomeChartGroupByType :application-id="record.id" />
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">آمار لیگ ها</h4>
          <LeaguesChart :application-id="record.id" />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">آمار نوتیفیکشن ها</h4>
          <NotificationsChart :application-id="record.id" />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">آمار استفاده از سرور</h4>
          <div id="data-usage-chart" class="apex-charts"></div>
          <apexchart
            class="apex-charts"
            height="230"
            dir="rtl"
            :series="dataUsageSeries"
            :options="dataUsageChartOptions"
          ></apexchart>
          <div class="row flex flex-wrap">
            <div :key="i" class="mx-2" v-for="(item, i) in dataUsageSeries">
              <div class="text-center mt-4">
                <p class="mb-2 text-truncate">
                  <i
                    class="mdi mdi-circle font-size-10 mr-1"
                    :style="{ color: chartOptions.colors[i] }"
                  ></i>
                  {{ dataUsageChartOptions.labels[i] }}
                </p>
                <h5>
                  {{
                    item !== 0
                      ? Math.round(
                          (item * 100) /
                            (record.applicationsDatabaseSize +
                              record.leaguesDatabaseSize)
                        )
                      : 0
                  }}%
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IncomeChartGroupByType from '@/components/income/ChartGroupByType'
import LeaguesChart from '@/components/league/ChartGroupByStatus'
import NotificationsChart from '@/components/notification/ChartGroupByStatus'

export default {
  components: { IncomeChartGroupByType, LeaguesChart, NotificationsChart },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    campaignSeries() {
      return [
        this.record.activeCampaignsCount,
        this.record.inactiveCampaignsCount,
        this.record.awaitingApprovalCampaignsCount,
      ]
    },
    dataUsageSeries() {
      return [
        Math.round(this.record.applicationsDatabaseSize * 100) / 100,
        Math.round(this.record.leaguesDatabaseSize * 100) / 100,
      ]
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 230,
          type: 'donut',
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: '75%',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        colors: [
          '#f63e3e',
          '#eeb902',
          '#1cbb8c',
          '#5664d2',
          '#03d3fc',
          '#fc6f03',
          '#b2c8d9',
          '#c969be',
          '#03ffc4',
        ],
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value
              Number += ''
              Number = Number.replace(',', '')
              const x = Number.split('.')
              let y = x[0]
              const z = x.length > 1 ? '.' + x[1] : ''
              const rgx = /(\d+)(\d{3})/
              while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
              return y + z + ' عدد'
            },
          },
        },
      },
      campaignChartLabels: ['فعال', 'غیر فعال', 'در انتظار تایید'],
      dataUsageChartOptions: {
        chart: {
          height: 230,
          type: 'donut',
        },
        labels: ['اپلیکیشن ها', 'لیگ ها'],
        plotOptions: {
          pie: {
            donut: {
              size: '75%',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        colors: [
          '#f63e3e',
          '#eeb902',
          '#1cbb8c',
          '#5664d2',
          '#03d3fc',
          '#fc6f03',
          '#b2c8d9',
          '#c969be',
          '#03ffc4',
        ],
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value
              Number += ''
              Number = Number.replace(',', '')
              const x = Number.split('.')
              let y = x[0]
              const z = x.length > 1 ? '.' + x[1] : ''
              const rgx = /(\d+)(\d{3})/
              while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
              return y + z + ' مگابایت'
            },
          },
        },
      },
    }
  },
  methods: {
    total(series) {
      if (series.length > 0) {
        const reducer = (accumulator, curr) => accumulator + curr
        return series.reduce(reducer)
      } else {
        return 0
      }
    },
  },
}
</script>
